var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 10,
    viewBox: "0 0 10 9",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.39201 8.31694C5.14573 8.07286 5.14573 7.67714 5.39201 7.43306L7.84698 5L1.29739 5C0.949101 5 0.666758 4.72018 0.666758 4.375C0.666758 4.02982 0.949101 3.75 1.29739 3.75L7.84698 3.75L5.64426 1.56694C5.39798 1.32286 5.39798 0.927136 5.64426 0.683058C5.89054 0.43898 6.28983 0.43898 6.53611 0.683058L9.81538 3.93306C10.0617 4.17714 10.0617 4.57286 9.81538 4.81694L6.28385 8.31694C6.03758 8.56102 5.63828 8.56102 5.39201 8.31694Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.170e019c683d14d5dcf32ef99f77d9fa.svg";
export { ForwardRef as ReactComponent };